/**
 * @generated SignedSource<<78f064847c6614740770dfb0394e9d66>>
 * @relayHash 7ddae986c3114a727b72b017ff9dffcf
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7ddae986c3114a727b72b017ff9dffcf

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VerifyMedicationStatus = "NONE" | "NOT_ENQUIRED" | "SOME";
export type Ch_verifyMedicationInput = {
  appointmentId: string;
  patientId: string;
  verifyMedicationStatus: VerifyMedicationStatus;
};
export type chVerifyMedicationMutation$variables = {
  input: Ch_verifyMedicationInput;
};
export type chVerifyMedicationMutation$data = {
  readonly ch_verifyMedication: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly medicationVerification: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"MedicationVerificationFragment">;
    } | null;
  };
};
export type chVerifyMedicationMutation = {
  response: chVerifyMedicationMutation$data;
  variables: chVerifyMedicationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chVerifyMedicationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_verifyMedicationPayload",
        "kind": "LinkedField",
        "name": "ch_verifyMedication",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MedicationVerification",
            "kind": "LinkedField",
            "name": "medicationVerification",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MedicationVerificationFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chVerifyMedicationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_verifyMedicationPayload",
        "kind": "LinkedField",
        "name": "ch_verifyMedication",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MedicationVerification",
            "kind": "LinkedField",
            "name": "medicationVerification",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "appointmentId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verifiedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verifiedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "verifyMedicationStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7ddae986c3114a727b72b017ff9dffcf",
    "metadata": {},
    "name": "chVerifyMedicationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "976feb84e0a39f8afda9c144a2ee6930";

export default node;
